import { useState } from 'react';
import { useCurrentTheme } from '../hooks/useCurrentTheme';
import {
    Modal,
    Box,
    IconButton,
    Typography,
    ModalDialog,
    Button,
    Link
} from '@mui/joy';
import { X } from '@phosphor-icons/react';

const ModalShowHistory = () => (
    <>
        <Typography sx={{ mb: 1 }}>
            Проект основан на базе данных «За Христа пострадавшие», созданной Православным Свято-Тихоновским гуманитарным университетом в 1990-е годы. Цель проекта — собрать и систематизировать сведения о судьбах православных христиан, подвергшихся репрессиям в XX веке.
        </Typography>
        <Typography sx={{ mb: 1 }}>
            Сегодня в базе десятки тысяч биографических справок, основанных на архивных документах и исследованиях историков.
        </Typography>
    </>
)

const ModalShowTech = () => (
    <>
        <Typography sx={{ mb: 1 }}>
            Мини-приложение ВКонтакте создано на React + JoyUI и подключено к экосистеме VK Mini Apps.
        </Typography>
        <Typography sx={{ mb: 1 }}>
            Отдельная страница «Подробнее» работает на PHP.
        </Typography>
        <Typography sx={{ mb: 1 }}>
            Оба интерфейса обращаются к серверу, который ежедневно формирует данные о новомучениках на текущую дату.
        </Typography>
    </>
)

const ModalShowUseless = () => (
    <>
        <Typography sx={{ mb: 1 }}>
            Данные проекта размещены в открытом доступе для всех заинтересованных пользователей — исследователей, студентов, верующих и просто тех, кто интересуется историей Церкви.
        </Typography>
        <Typography sx={{ mb: 1 }}>
            При цитировании рекомендуется указывать источник:
        </Typography>
        <ul style={{ paddingLeft: '24px' }}>
            <li>
                База данных «За Христа пострадавшие» (ПСТГУ)
            </li>
            <li>
                Ссылка на сайт проекта:{' '}
                <Link
                    href="https://pstgu.ru"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="сайт Православного Свято-Тихоновский гуманитарный университет">pstgu.ru</Link>
            </li>
        </ul>
    </>
)

const ModalShowReason = () => (
    <>
        <Typography sx={{ mb: 1 }}>
            Наш проект — это напоминание о людях, которые сохранили верность Христу и пожертвовали собой.
        </Typography>
        <Typography sx={{ mb: 1 }}>
            Мы хотим, чтобы их имена и подвиги не были забыты, а память о новомучениках стала частью духовного наследия и помогала современным людям понимать историю своей страны и Церкви.
        </Typography>
    </>
)

const ModalShowAboutus = () => (
    <>
        <Typography sx={{ mb: 1 }}>
            Разработчик мини-приложения:
        </Typography>
        <Typography sx={{ mb: 1 }}>
            Даниил Дыбка, <Link href="mailto:daniil@dybka.ru" aria-label="Написать на почту разработчика">
                daniil@dybka.ru
            </Link>
        </Typography>
    </>
)

const ModalShowHelpproject = () => (
    <>
        <Typography sx={{ mb: 1 }}>
            Вы можете поддержать развитие проекта:
        </Typography>

        <ul style={{ paddingLeft: '24px' }}>
            <li>
                Участвовать как волонтёр (помощь в сборе и уточнении информации).
            </li>
            <li>
                Делать предложения по улучшению интерфейса и работы виджета.
            </li>
            <li>
                Распространять информацию о проекте среди тех, кому он может быть полезен.
            </li>
        </ul>
    </>
)

function ModalShow({ open, setOpen }) {
    const theme = useCurrentTheme();
    const [modalText, setModalText] = useState('history');

    const titleModal = (modalText) => {
        switch (modalText) {
            case 'history':
                return 'История проекта'
            case 'tech':
                return 'Техническая информация'
            case 'useless':
                return 'Доступность и использование данных'
            case 'reason':
                return 'Зачем мы это делаем'
            case 'aboutus':
                return 'Кто мы'
            case 'helpproject':
                return 'Как помочь проекту'
            default:
                return 'Раздел не найден'
        }
    }

    const descriptionModal = (modalText) => {
        switch (modalText) {
            case 'history':
                return <ModalShowHistory />
            case 'tech':
                return <ModalShowTech />
            case 'useless':
                return <ModalShowUseless />
            case 'reason':
                return <ModalShowReason />
            case 'aboutus':
                return <ModalShowAboutus />
            case 'helpproject':
                return <ModalShowHelpproject />
            default:
                return 'К сожалению, указанный раздел не найден.'
        }
    }

    const activeModalText = (currentModalText) => {
        return modalText.toLowerCase() === currentModalText.toLowerCase()
    }

    const list = [
        {
            title: 'История проекта',
            data: 'history',
        },
        {
            title: 'Техническая информация',
            data: 'tech',
        },
        {
            title: 'Доступность и использование данных',
            data: 'useless',
        },
        {
            title: 'Зачем мы это делаем',
            data: 'reason',
        },
        {
            title: 'Кто мы',
            data: 'aboutus',
        },
        {
            title: 'Как помочь проекту',
            data: 'helpproject',
        },
    ]

    const changeModalText = (changeText) => {
        const check = [
            'history',
            'tech',
            'useless',
            'reason',
            'aboutus',
            'helpproject',
        ].includes(changeText)

        setModalText(check ? changeText : 'history')
    }

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <ModalDialog
                variant="outlined"
                sx={{
                    maxWidth: 500,
                    borderRadius: '32px',
                    border: 'none',
                    p: 3,
                    boxShadow: 'lg',
                    backgroundColor: theme.card.bg,
                    boxSizing: 'border-box',
                    maxHeight: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                    '@media (max-width: 540px)': {
                        maxWidth: 'calc(100% - 40px)',
                    },
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    whiteSpace: 'pre-wrap',
                }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 1,
                    }}
                >
                    <Typography level="title-lg" sx={{ pr: 3, color: theme.text.title }}>
                        {titleModal(modalText)}
                    </Typography>
                    <IconButton
                        aria-label="Закрыть"
                        onClick={() => setOpen(false)}
                        variant="plain"
                        color="neutral"
                        sx={{
                            borderRadius: '50px',
                            '&:hover': {
                                backgroundColor: theme.chevron.bgHover
                            },
                            '&:active': {
                                backgroundColor: theme.chevron.bgActive
                            },
                        }}
                    >
                        <X
                            size={20}
                            fill={theme.chevron.active}
                        />
                    </IconButton>
                </Box>

                <Box
                    sx={{
                        overflowY: 'auto',
                        flexGrow: 1,
                        minHeight: 0,
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                            overflowX: 'auto',
                            mb: 2,
                            '&::-webkit-scrollbar': { display: 'none' },
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none',
                        }}
                    >
                        {list.map((item, index) => (
                            <Button
                                key={`button-${index}`}
                                size="sm"
                                variant={activeModalText(item?.data) ? 'solid' : 'outlined'}
                                onClick={() => changeModalText(item?.data)}
                                sx={{
                                    borderRadius: '50px',
                                    whiteSpace: 'nowrap',
                                    px: 2,
                                    minWidth: 'auto',
                                    fontSize: '0.75rem',
                                }}
                            >
                                {item?.title}
                            </Button>
                        ))}
                    </Box>
                    <Box sx={{
                        '& p': {
                            color: theme.text.boxModal,
                        },
                        '& ul': {
                            color: theme.text.boxModal,
                        },
                    }}>
                        {descriptionModal(modalText)}
                    </Box>
                </Box>
            </ModalDialog>
        </Modal>
    )
}

export default ModalShow
